import { useQuery, useMutation, useQueryClient, keepPreviousData } from '@tanstack/react-query'
import { toast } from 'sonner'
import {
  cpGetMobileConfig,
  cpPublishMobileConfig,
  type PublishMobileConfigPayload,
} from '@/lib/api/controlPlaneClient'

export const MOBILE_CONFIG_QUERY_KEY = ['storefront-mobile-config'] as const

export function useMobileConfig() {
  const queryClient = useQueryClient()

  const configQuery = useQuery({
    queryKey: MOBILE_CONFIG_QUERY_KEY,
    queryFn: cpGetMobileConfig,
    placeholderData: keepPreviousData,
  })

  const publishMutation = useMutation({
    mutationFn: (payload: PublishMobileConfigPayload) => cpPublishMobileConfig(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: MOBILE_CONFIG_QUERY_KEY })
      toast.success('บันทึกสำเร็จ — สไตล์มือถือจะมีผลทันที')
    },
    onError: (error: Error) => {
      toast.error(error.message || 'บันทึกไม่สำเร็จ กรุณาลองอีกครั้ง')
    },
  })

  return {
    config: configQuery.data ?? null,
    isLoading: configQuery.isLoading,
    publish: publishMutation.mutate,
    isPublishing: publishMutation.isPending,
  }
}
